import React from "react";
import PropTypes from "prop-types";
import { Button, Dialog, Stack, Typography } from "@mui/material";

/**
 * 프로필 생년월일 변경 시 기존 아동 정보 수집·이용 동의 철회 안내 (Figma: 포코로 상세 정보 / 프로필 변경 - 변경전 모달)
 */
export default function BirthDateChangeConsentDialog(props) {
  const { open, title, body, cancelLabel, continueLabel, onCancel, onContinue } =
    props;

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      PaperProps={{
        sx: {
          margin: 2,
          width: "100%",
          maxWidth: 328,
          borderRadius: "20px",
          padding: "32px 24px",
          boxSizing: "border-box",
        },
      }}
      BackdropProps={{
        sx: { backgroundColor: "rgba(0, 0, 0, 0.5)" },
      }}
    >
      <Stack spacing={3} alignItems="center" width="100%">
        <Stack spacing={1} alignItems="center" width="100%">
          <Typography
            sx={{
              fontSize: "18px",
              fontWeight: 700,
              color: "#333",
              textAlign: "center",
              lineHeight: 1.4,
            }}
          >
            {title}
          </Typography>
          <Typography
            sx={{
              fontSize: "14px",
              fontWeight: 400,
              color: "#757575",
              textAlign: "center",
              lineHeight: 1.4,
              whiteSpace: "pre-line",
            }}
          >
            {body}
          </Typography>
        </Stack>
        <Stack direction="row" spacing={1} width="100%">
          <Button
            fullWidth
            disableRipple
            onClick={onCancel}
            sx={{
              py: 2,
              px: 2,
              borderRadius: "8px",
              textTransform: "none",
              fontSize: "14px",
              lineHeight: 1.4,
              color: "#757575",
              backgroundColor: "#fff",
              border: "1px solid #BFBFBF",
              boxSizing: "border-box",
              "&:hover": {
                backgroundColor: "#fff",
                border: "1px solid #BFBFBF",
              },
            }}
          >
            {cancelLabel}
          </Button>
          <Button
            fullWidth
            disableRipple
            onClick={onContinue}
            sx={{
              py: 2,
              px: 2,
              borderRadius: "8px",
              textTransform: "none",
              fontSize: "14px",
              lineHeight: 1.4,
              color: "#333",
              backgroundColor: "#FDD751",
              border: "2px solid #FDD751",
              boxSizing: "border-box",
              "&:hover": {
                backgroundColor: "#FDD751",
                border: "2px solid #FDD751",
              },
            }}
          >
            {continueLabel}
          </Button>
        </Stack>
      </Stack>
    </Dialog>
  );
}

BirthDateChangeConsentDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  cancelLabel: PropTypes.string.isRequired,
  continueLabel: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  onContinue: PropTypes.func.isRequired,
};
